import { PlusNetworkOutlineIcon } from './PlusNetworkOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 349600D3-B39C-46C2-8E61-5A256C4BA98C
 * name plus-network-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/plus-network-outline.svg
 * tags
 */
export const AddNetworkOutlineIcon = PlusNetworkOutlineIcon;
export default AddNetworkOutlineIcon